// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: calc(8px + 1.5vmin);
  padding: 20px;
  box-sizing: border-box;
}

h1 {
  font-size: calc(16px + 2vmin);
  margin-bottom: 20px;
}

h2 {
  font-size: calc(14px + 1.5vmin);
  margin-top: 0;
  margin-bottom: 15px;
}

.control-buttons {
  margin-bottom: 20px;
}

button {
  font-size: calc(8px + 1vmin);
  margin: 10px;
  padding: 8px 16px;
  cursor: pointer;
}

.status {
  margin-bottom: 20px;
}

.settings-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
}

.current-settings, .update-settings {
  width: 48%;
}

form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

label {
  margin: 5px 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

input {
  margin-left: 10px;
  font-size: calc(8px + 1vmin);
}

pre {
  text-align: left;
  background-color: #f0f0f0;
  padding: 15px;
  border-radius: 5px;
  font-size: calc(7px + 1vmin);
  white-space: pre-wrap;
  word-wrap: break-word;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.swap-history-container {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 8px;
  width: 100%;
  overflow-x: auto;
}

.swap-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
}

.swap-item {
  display: flex;
  align-items: center;
  gap: 20px;
  background-color: white;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  flex-wrap: wrap;
  font-size: calc(10px + 1vmin);
}

.swap-item p {
  margin: 0;
  white-space: nowrap;
}

.tx-links {
  display: flex;
  gap: 1rem;
  margin: 0;
  font-size: calc(10px + 1vmin);
}

.tx-links a {
  color: #0066cc;
  text-decoration: none;
  white-space: nowrap;
}

.tx-links a:hover {
  text-decoration: underline;
}

.logs-container {
  margin-top: 2rem;
  width: 100%;
  max-width: 1200px;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
}

.logs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 10px;
}

.logs-header h2 {
  margin: 0;
}

.logs-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 1rem;
}

.log-item {
  display: flex;
  gap: 1rem;
  padding: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
  font-family: monospace;
  font-size: calc(9px + 1vmin); /* Updated to your requested size */
}

.log-time {
  color: #666;
  white-space: nowrap;
  font-size: calc(9px + 1vmin); /* Updated to match log-item */
}

.log-message {
  word-break: break-all;
  font-size: calc(9px + 1vmin); /* Updated to match log-item */
}

.clear-logs-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.clear-logs-btn:hover {
  background-color: #c82333;
}

/* Add these media queries for mobile responsiveness */
@media screen and (max-width: 768px) {
  .App {
    padding: 10px;
    font-size: calc(10px + 1vmin);
  }

  .settings-container {
    flex-direction: column;
  }

  .current-settings, .update-settings {
    width: 100%;
    margin-bottom: 20px;
  }

  .swap-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    font-size: calc(12px + 1vmin);
  }

  .swap-item p {
    margin: 5px 0;
  }

  .tx-links {
    width: 100%;
    justify-content: space-between;
  }

  form label {
    flex-direction: column;
    align-items: flex-start;
    margin: 10px 0;
  }

  form input {
    margin-left: 0;
    margin-top: 5px;
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
  }

  button {
    width: 100%;
    margin: 5px 0;
    padding: 12px;
    font-size: calc(12px + 1vmin);
  }

  .control-buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .logs-container {
    margin-top: 1rem;
  }

  .log-item {
    flex-direction: column;
    gap: 5px;
  }

  .log-time {
    font-size: calc(10px + 1vmin);
  }

  .log-message {
    font-size: calc(10px + 1vmin);
  }

  pre {
    font-size: calc(10px + 1vmin);
    padding: 10px;
  }

  h1 {
    font-size: calc(18px + 2vmin);
    margin-bottom: 15px;
  }

  h2 {
    font-size: calc(16px + 1.5vmin);
    margin-bottom: 10px;
  }
}

/* Add specific styles for very small screens */
@media screen and (max-width: 480px) {
  .App {
    padding: 5px;
  }

  .swap-history-container {
    margin-top: 1rem;
    padding: 0.5rem;
  }

  .swap-item {
    padding: 0.5rem;
    font-size: calc(11px + 1vmin);
  }

  .logs-content {
    max-height: 300px;
    padding: 0.5rem;
  }

  .logs-header {
    padding: 5px;
  }

  .clear-logs-btn {
    padding: 8px;
    font-size: calc(10px + 1vmin);
  }
}

/* Add styles for landscape orientation on mobile */
@media screen and (max-width: 768px) and (orientation: landscape) {
  .logs-content {
    max-height: 200px;
  }

  .settings-container {
    flex-direction: row;
  }

  .current-settings, .update-settings {
    width: 48%;
  }
}

/* Add these styles to your existing CSS file */

.balances-container {
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 8px;
  margin: 10px 0;
  width: 100%;
  max-width: 1200px;
}

.balances-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
}

.balance-item {
  background-color: white;
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.balance-item p {
  margin: 0;
  font-size: calc(8px + 1vmin);
}

/* Add mobile responsiveness */
@media screen and (max-width: 768px) {
  .balances-container {
    padding: 8px;
    margin: 8px 0;
  }

  .balances-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .balance-item {
    padding: 6px 10px;
  }
}

.home-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
    gap: 20px;
}

.iol-button {
    background-color: #4CAF50;  /* Green */
    color: white;
    padding: 15px 32px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    min-width: 200px;
    transition: background-color 0.3s;
}

.iol-button:hover {
    background-color: #45a049;
}

.cyb-button {
    background-color: #2196F3;  /* Blue */
    color: white;
    padding: 15px 32px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    min-width: 200px;
    transition: background-color 0.3s;
}

.cyb-button:hover {
    background-color: #1976D2;
}

/* Add this to your mobile media query section */
@media screen and (max-width: 768px) {
    .iol-button, .cyb-button {
        min-width: 160px;
        padding: 12px 24px;
    }
}

.header-container {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.back-button {
    text-decoration: none;
    color: #666;
    padding: 8px 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.back-button:hover {
    background-color: #f0f0f0;
    color: #333;
}

.iol-text {
    color: #4CAF50;  /* Green color matching your existing theme */
}
.cyb-text {
  color: #374ec0;  /* Green color matching your existing theme */
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    width: 90%;
}

.modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
}

.modal-buttons button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.modal-confirm {
    background-color: #dc3545;
    color: white;
}

.modal-cancel {
    background-color: #6c757d;
    color: white;
}

.title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.bot-status {
    font-size: 0.8em;
    margin-top: -15px;
    font-weight: 500;
}

.bot-status.running {
    color: #4CAF50;  /* Green */
}

.bot-status.stopped {
    color: #dc3545;  /* Red */
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,sBAAsB;EACtB,4BAA4B,EAAE,mCAAmC;AACnE;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,4BAA4B,EAAE,8BAA8B;AAC9D;;AAEA;EACE,qBAAqB;EACrB,4BAA4B,EAAE,8BAA8B;AAC9D;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;EACE;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,6BAA6B;EAC/B;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,+CAA+C;;AAE/C;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yBAAyB,GAAG,UAAU;IACtC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB,GAAG,SAAS;IACrC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gDAAgD;AAChD;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc,GAAG,6CAA6C;AAClE;AACA;EACE,cAAc,GAAG,6CAA6C;AAChE;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc,GAAG,UAAU;AAC/B;;AAEA;IACI,cAAc,GAAG,QAAQ;AAC7B","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: calc(8px + 1.5vmin);\n  padding: 20px;\n  box-sizing: border-box;\n}\n\nh1 {\n  font-size: calc(16px + 2vmin);\n  margin-bottom: 20px;\n}\n\nh2 {\n  font-size: calc(14px + 1.5vmin);\n  margin-top: 0;\n  margin-bottom: 15px;\n}\n\n.control-buttons {\n  margin-bottom: 20px;\n}\n\nbutton {\n  font-size: calc(8px + 1vmin);\n  margin: 10px;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.status {\n  margin-bottom: 20px;\n}\n\n.settings-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.current-settings, .update-settings {\n  width: 48%;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\nlabel {\n  margin: 5px 0;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\ninput {\n  margin-left: 10px;\n  font-size: calc(8px + 1vmin);\n}\n\npre {\n  text-align: left;\n  background-color: #f0f0f0;\n  padding: 15px;\n  border-radius: 5px;\n  font-size: calc(7px + 1vmin);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.swap-history-container {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  width: 100%;\n  overflow-x: auto;\n}\n\n.swap-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.swap-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  background-color: white;\n  padding: 1rem;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  flex-wrap: wrap;\n  font-size: calc(10px + 1vmin);\n}\n\n.swap-item p {\n  margin: 0;\n  white-space: nowrap;\n}\n\n.tx-links {\n  display: flex;\n  gap: 1rem;\n  margin: 0;\n  font-size: calc(10px + 1vmin);\n}\n\n.tx-links a {\n  color: #0066cc;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.tx-links a:hover {\n  text-decoration: underline;\n}\n\n.logs-container {\n  margin-top: 2rem;\n  width: 100%;\n  max-width: 1200px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.logs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n}\n\n.logs-header h2 {\n  margin: 0;\n}\n\n.logs-content {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 1rem;\n}\n\n.log-item {\n  display: flex;\n  gap: 1rem;\n  padding: 0.5rem;\n  border-bottom: 1px solid #e0e0e0;\n  font-family: monospace;\n  font-size: calc(9px + 1vmin); /* Updated to your requested size */\n}\n\n.log-time {\n  color: #666;\n  white-space: nowrap;\n  font-size: calc(9px + 1vmin); /* Updated to match log-item */\n}\n\n.log-message {\n  word-break: break-all;\n  font-size: calc(9px + 1vmin); /* Updated to match log-item */\n}\n\n.clear-logs-btn {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.clear-logs-btn:hover {\n  background-color: #c82333;\n}\n\n/* Add these media queries for mobile responsiveness */\n@media screen and (max-width: 768px) {\n  .App {\n    padding: 10px;\n    font-size: calc(10px + 1vmin);\n  }\n\n  .settings-container {\n    flex-direction: column;\n  }\n\n  .current-settings, .update-settings {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n\n  .swap-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    font-size: calc(12px + 1vmin);\n  }\n\n  .swap-item p {\n    margin: 5px 0;\n  }\n\n  .tx-links {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  form label {\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 10px 0;\n  }\n\n  form input {\n    margin-left: 0;\n    margin-top: 5px;\n    width: 100%;\n    padding: 8px;\n    box-sizing: border-box;\n  }\n\n  button {\n    width: 100%;\n    margin: 5px 0;\n    padding: 12px;\n    font-size: calc(12px + 1vmin);\n  }\n\n  .control-buttons {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .logs-container {\n    margin-top: 1rem;\n  }\n\n  .log-item {\n    flex-direction: column;\n    gap: 5px;\n  }\n\n  .log-time {\n    font-size: calc(10px + 1vmin);\n  }\n\n  .log-message {\n    font-size: calc(10px + 1vmin);\n  }\n\n  pre {\n    font-size: calc(10px + 1vmin);\n    padding: 10px;\n  }\n\n  h1 {\n    font-size: calc(18px + 2vmin);\n    margin-bottom: 15px;\n  }\n\n  h2 {\n    font-size: calc(16px + 1.5vmin);\n    margin-bottom: 10px;\n  }\n}\n\n/* Add specific styles for very small screens */\n@media screen and (max-width: 480px) {\n  .App {\n    padding: 5px;\n  }\n\n  .swap-history-container {\n    margin-top: 1rem;\n    padding: 0.5rem;\n  }\n\n  .swap-item {\n    padding: 0.5rem;\n    font-size: calc(11px + 1vmin);\n  }\n\n  .logs-content {\n    max-height: 300px;\n    padding: 0.5rem;\n  }\n\n  .logs-header {\n    padding: 5px;\n  }\n\n  .clear-logs-btn {\n    padding: 8px;\n    font-size: calc(10px + 1vmin);\n  }\n}\n\n/* Add styles for landscape orientation on mobile */\n@media screen and (max-width: 768px) and (orientation: landscape) {\n  .logs-content {\n    max-height: 200px;\n  }\n\n  .settings-container {\n    flex-direction: row;\n  }\n\n  .current-settings, .update-settings {\n    width: 48%;\n  }\n}\n\n/* Add these styles to your existing CSS file */\n\n.balances-container {\n  background-color: #f5f5f5;\n  padding: 12px;\n  border-radius: 8px;\n  margin: 10px 0;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.balances-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 8px;\n}\n\n.balance-item {\n  background-color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.balance-item p {\n  margin: 0;\n  font-size: calc(8px + 1vmin);\n}\n\n/* Add mobile responsiveness */\n@media screen and (max-width: 768px) {\n  .balances-container {\n    padding: 8px;\n    margin: 8px 0;\n  }\n\n  .balances-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 6px;\n  }\n\n  .balance-item {\n    padding: 6px 10px;\n  }\n}\n\n.home-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 80vh;\n    gap: 20px;\n}\n\n.iol-button {\n    background-color: #4CAF50;  /* Green */\n    color: white;\n    padding: 15px 32px;\n    border: none;\n    border-radius: 4px;\n    font-size: 16px;\n    min-width: 200px;\n    transition: background-color 0.3s;\n}\n\n.iol-button:hover {\n    background-color: #45a049;\n}\n\n.cyb-button {\n    background-color: #2196F3;  /* Blue */\n    color: white;\n    padding: 15px 32px;\n    border: none;\n    border-radius: 4px;\n    font-size: 16px;\n    min-width: 200px;\n    transition: background-color 0.3s;\n}\n\n.cyb-button:hover {\n    background-color: #1976D2;\n}\n\n/* Add this to your mobile media query section */\n@media screen and (max-width: 768px) {\n    .iol-button, .cyb-button {\n        min-width: 160px;\n        padding: 12px 24px;\n    }\n}\n\n.header-container {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.back-button {\n    text-decoration: none;\n    color: #666;\n    padding: 8px 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    transition: all 0.3s ease;\n}\n\n.back-button:hover {\n    background-color: #f0f0f0;\n    color: #333;\n}\n\n.iol-text {\n    color: #4CAF50;  /* Green color matching your existing theme */\n}\n.cyb-text {\n  color: #374ec0;  /* Green color matching your existing theme */\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    max-width: 400px;\n    width: 90%;\n}\n\n.modal-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 20px;\n}\n\n.modal-buttons button {\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.modal-confirm {\n    background-color: #dc3545;\n    color: white;\n}\n\n.modal-cancel {\n    background-color: #6c757d;\n    color: white;\n}\n\n.title-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.bot-status {\n    font-size: 0.8em;\n    margin-top: -15px;\n    font-weight: 500;\n}\n\n.bot-status.running {\n    color: #4CAF50;  /* Green */\n}\n\n.bot-status.stopped {\n    color: #dc3545;  /* Red */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
